/** Shared with the skeleton, so the swap to loaded content does not shift the layout. */
export const PROVIDER_CARD_CLASS = 'flex flex-col gap-md rounded-2xl bg-surface p-lg';
export const PROVIDER_GRID_CLASS = 'grid grid-cols-2 gap-sm sm:grid-cols-3 lg:grid-cols-5';
export const PROVIDER_TILE_CLASS =
  'flex min-h-28 flex-col justify-between gap-md rounded-lg border border-border-light bg-background p-md';
